module.exports = __webpack_public_path__ + "img/outlet.d68ce4da.svg";